const deliveryCar = () => import('@/pages/deliveryCar')
const createDelivery = () => import('@/pages/deliveryCar/createDelivery')
const createPaperlessDeliveryCar = () => import('@/pages/deliveryCar/createPaperlessDeliveryCar')
export default [{
  path: '/deliveryCar',
  name: 'deliveryCar',
  component: deliveryCar,
  meta: {
    storeKey: 'trs.deliveryCar.index'
  }
},
{
  path: '/createDelivery',
  name: 'createDelivery',
  component: createDelivery,
  meta: {}
},
{
  path: '/createPaperlessDeliveryCar',
  name: 'createPaperlessDeliveryCar',
  component: createPaperlessDeliveryCar,
  meta: {}
}
]



// WEBPACK FOOTER //
// ./src/router/deliveryCar/index.js